// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePdfOutlinedSvg from "@fishx/icons-svg/es/asn/FilePdfOutlined";
import FishxIcon from '../components/FishxIcon';

var FilePdfOutlined = function FilePdfOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfOutlinedSvg
  }));
};

FilePdfOutlined.displayName = 'FilePdfOutlined';
export default React.forwardRef(FilePdfOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilePdfOutlined.js
// module id = 2732
// module chunks = 0